<template>
  <div v-html="content_section">
      <!-- section id="dlealp_section_about" class="about_area p_120">
        <div class="container">
        <div class="about_inner row">
        <div class="col-lg-6">
        <div class="about_left_text">
        <h3>Conhe&ccedil;a a Dlealp</h3>
        
        <p>De pequena indústria de móveis para uma empresa sólida com importante participação no mercado. Essa é a trajetória da D’lealp Interiores. </p>
        <p>Criada em 1998, com sede em Taguatinga/DF, a D’lealp Interiores foi se transformando ao longo dos anos. Seu crescimento levou a um segmento importante no Distrito Federal e região: a participação em licitações para o Governo Distrital e Federal.</p>
        <p>Em apenas quatro anos, a empresa investiu muito em sua estrutura. Para ganhar mais espaço, mudou sua sede para o Setor Industrial, em Ceilândia/DF, passou a gerar mais empregos. E, atualmente, continua colhendo os frutos deste investimento, ao executar trabalhos para pessoas física e jurídica, em todo o DF.</p>
        <p>Em 2010, novas reestruturações físicas e políticas. A nova missão implicou em um espaço ainda mais amplo inaugurado no Setor de Material de Construção, também em Ceilândia/DF. Desde então, a D’lealp Interiores prioriza os negócios jurídicos e governamentais, que seguem essa história de sucesso.</p>

        <a class="main_btn" href="/galeria">Conhe&ccedil;a nosso trabalho</a></div>
        </div>
        <div class="col-lg-6"><img class="img-fluid" src="img/banner/about-1.jpg" alt="" /></div>
        </div>
        </div>
    </section -->
  </div>
</template>

<script>
export default {
    name: 'About',
    props: {
      content_section: String,
    },
}
</script>

<style>

  #dlealp_section_about p {
    margin-bottom: 20px;
    text-align: justify;
    
  }

</style>